import { ExcalidrawElement } from '@excalidraw/excalidraw/types/element/types';
import { useQuery } from '@tanstack/react-query';
import Axios from 'axios';

import BackendService from '../services/backendService';

export const useGameMediaBackgroundJSONFile = (fileId?: string | null) => {
  const { data, isFetching, error } = useQuery(
    ['game-file-json', fileId],
    async () => {
      if (!fileId) return Promise.resolve(undefined);
      const urlRes = await BackendService.instance.getDownloadUrl(fileId);
      if (urlRes) {
        const res = await Axios.request<ExcalidrawElement[]>({
          method: 'get',
          url: urlRes.data.url,
          responseType: 'json',
        });
        const elements = res.data;
        return elements;
      }
      return Promise.resolve(undefined);
    },
    {
      enabled: Boolean(fileId),
      staleTime: 1000 * 60 * 5,
    },
  );

  return {
    data,
    isLoading: isFetching,
    error,
  };
};

export const useTextFile = (fileId: string) => {
  const { data, isFetching, error } = useQuery(
    ['game-file-text', fileId],
    async () => {
      const urlRes = await BackendService.instance.getDownloadUrl(fileId);
      if (urlRes) {
        const res = await Axios.request<string>({
          method: 'get',
          url: urlRes.data.url,
        });
        const elements = res.data;
        return elements;
      }
      return Promise.resolve(undefined);
    },
    {
      staleTime: 1000 * 60 * 5,
    },
  );

  return {
    data,
    isLoading: isFetching,
    error,
  };
};
